// extracted by mini-css-extract-plugin
module.exports = {"supported_file":"UploadImage_supported_file__2MqoY","button":"UploadImage_button__2hpZa","rcUpload":"UploadImage_rcUpload__3XZYh"};